import React, { useState, useEffect } from 'react';
import { Icon } from '@iconify/react';
import {
  LazyLoadImage,
  trackWindowScroll,
} from 'react-lazy-load-image-component';
import 'react-lazy-load-image-component/src/effects/blur.css';

const AboutSection = ({ scrollPosition }) => {
  const [isInView, setIsInView] = useState(false);

  useEffect(() => {
    const sectionElement = document.getElementById('about');
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => setIsInView(entry.isIntersecting));
      },
      { threshold: 0.1 },
    );

    if (sectionElement) observer.observe(sectionElement);

    return () => {
      if (sectionElement) observer.unobserve(sectionElement);
    };
  }, []);

  const sectionStyle = {
    transition: 'opacity 0.5s ease, transform 0.5s ease',
    opacity: isInView ? 1 : 0,
    transform: isInView ? 'translateY(0)' : 'translateY(20px)',
    visibility: isInView ? 'visible' : 'hidden',
  };
  return (
    <section id="about" className="about section" style={sectionStyle}>
      <div className="container">
        <div className="row gy-4">
          <div
            className="col-lg-6 position-relative order-lg-last"
            data-aos="fade-up"
            data-aos-delay="300"
          >
            <LazyLoadImage
              src="/img/alur-1024.webp"
              srcSet="/img/alur-256.webp 256w,
                      /img/alur-512.webp 512w,
                      /img/alur-1024.webp 1024w"
              sizes="(max-width: 768px) 100vw, 50vw"
              className="img-fluid"
              alt="Alur Pelayanan RSUD H Abdul Manap Kota Jambi"
              effect="blur"
              width="1024"
              height="512"
              scrollPosition={scrollPosition}
            />
            <a
              href="https://www.youtube.com/watch?v=VAHuylv4mv8"
              className="glightbox pulsating-play-btn"
              aria-label="Alur Pelayanan RSUD H Abdul Manap Kota Jambi"
            >
              <Icon icon="mdi:play" className="play-icon" />
            </a>
          </div>

          <div
            className="col-lg-6 content"
            data-aos="fade-up"
            data-aos-delay="100"
          >
            <h3>Tentang Kita</h3>
            <p style={{ textAlign: 'justify' }}>
              <b>RSUD H. Abdul Manap Kota Jambi</b> berkomitmen untuk memberikan
              pelayanan kesehatan terbaik bagi masyarakat dengan motto
              <em>"Melayani Dengan Setulus Hati"</em>. Berlokasi di Jl. Sk. Rd.
              Syahbudin, Mayang Mangurai, Alam Barajo, Kota Jambi 36129, dan
              dipimpin oleh Direktur<b> dr. Anastasia Yekti Heningnurani, MARS</b>, kami
              menyediakan layanan kesehatan berkualitas dengan tenaga medis
              profesional, fasilitas modern, dan pendekatan yang mengutamakan
              kenyamanan serta kesejahteraan pasien.
            </p>
            <ul>
              <li>
                <Icon
                  icon="fluent:heart-pulse-20-filled"
                  className="icon-custom-about"
                />
                <div>
                  <h5>Pelayanan Kesehatan Berstandar Tinggi</h5>
                  <p>
                    Kami berkomitmen memberikan pelayanan kesehatan yang prima
                    dengan tenaga medis berpengalaman dan prosedur berbasis
                    standar internasional.
                  </p>
                </div>
              </li>
              <li>
                <Icon
                  icon="mdi:hospital-building"
                  className="icon-custom-about"
                />
                <div>
                  <h5>Fasilitas Modern dan Lengkap</h5>
                  <p>
                    Fasilitas lengkap dan modern kami siap menunjang kebutuhan
                    medis Anda, dengan teknologi terbaru untuk diagnosis dan
                    perawatan.
                  </p>
                </div>
              </li>
              <li>
                <Icon icon="mdi:hand-heart" className="icon-custom-about" />
                <div>
                  <h5>Pendekatan Pasien-Centered</h5>
                  <p>
                    Kami mendahulukan kenyamanan dan kesejahteraan pasien,
                    memberikan pendekatan layanan yang ramah, transparan, dan
                    bersahabat.
                  </p>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
};

export default trackWindowScroll(AboutSection);
